import logo from '../../../../img/flightscape-logo.png?url';
import background from '../../../../img/flightscape-logon-background.png?url';
import { envConfig, isDev } from '../../../configs/env';
import feVersion from '../../../utils/version-helper';

export function LoginFrame(props: { children?: React.ReactNode }) {
    return (
        <div
            className="h-100 w-100 d-flex flex-column align-items-center login-bg p-2 gap-2"
            style={{
                backgroundImage: `url("${background}")`,
                backgroundSize: 'cover',
                boxSizing: 'border-box'
            }}>
            <img
                src={logo}
                style={{
                    position: 'fixed',
                    left: 24,
                    top: 24
                }}
            />
            <div className="flex-grow-1"></div>
            <div>
                <div className="text-white text-end pb-5 pe-2 fw-bold">
                    <div style={{ fontSize: 48, lineHeight: '1.1' }}>Flight Explorer</div>
                    <div>Version {feVersion.version}</div>
                </div>
                <div className="k-card p-3" style={{ width: 'min(100vw, 375px)', borderRadius: 12 }}>
                    {props.children}
                </div>
            </div>

            <div className="flex-grow-1"></div>
            <div className="text-white text-center">
                <div>Copyright © {new Date().getFullYear()}, Flightscape Inc. All rights reserved.</div>
                {isDev(envConfig.type) && (
                    <div className="secondary-text">
                        CI Build: {feVersion.ciBuildNumberTemplate}@{feVersion.ciCommitIdTemplate}
                    </div>
                )}
            </div>
        </div>
    );
}
